import { Bank, banks } from 'const/australia-banks'

export const getBankByBsB = (bsb: string): Bank | undefined =>
  banks.find((bank) => bank.number.some((item) => bsb.startsWith(item))) ??
  banks.find((bank) => bank.numberShort.some((item) => bsb.startsWith(item)))
